import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import styles from './SortDropdown.module.scss';
import { Caret } from '../icons/caret';
export function SortDropdown({ options, currentSort, onChange, onMobileClick }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const dropdownRef = useRef(null);
    // Check if we're on mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 1200);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const currentOption = options.find(opt => opt.id === currentSort);
    const handleSelect = (optionId) => {
        onChange(optionId);
        setIsOpen(false);
    };
    const handleLabelClick = () => {
        if (isMobile && onMobileClick) {
            onMobileClick('sort');
        }
        else {
            setIsOpen(!isOpen);
        }
    };
    return (h("div", { class: styles.sortDropdown, ref: dropdownRef },
        h("div", { class: styles.sortLabel, onClick: handleLabelClick },
            h("div", { class: styles.sortLabelDesktop }, "Sort By: \u00A0"),
            h("div", { class: styles.sortLabelMobile }, "Sort"),
            h("div", { class: styles.sortLabelValue }, currentOption === null || currentOption === void 0 ? void 0 : currentOption.label),
            h("span", { class: `${styles.caret} ${isOpen ? styles.caretOpen : ''}` },
                h(Caret, null))),
        isOpen && (h("div", { class: styles.sortOptions }, options.map(option => (h("label", { key: option.id, class: styles.sortOption },
            h("input", { type: "radio", name: "sort", checked: option.id === currentSort, onChange: () => handleSelect(option.id) }),
            h("span", { class: styles.customRadio }),
            h("span", { class: styles.sortOptionText }, option.label))))))));
}
